export const BACK_TO_SCHOOL_BADGE = 'Back To School';

export function selectPromotionBadge({
    backToSchoolActive = false,
    categories = [],
    backToSchoolEligible,
    backToSchoolTitle = BACK_TO_SCHOOL_BADGE,
    backToSchoolCategory = BACK_TO_SCHOOL_BADGE,
    fallback = null,
} = {}) {
    const isBackToSchoolStyle = typeof backToSchoolEligible === 'boolean'
        ? backToSchoolEligible
        : Array.isArray(categories) && categories.includes(backToSchoolCategory);

    return backToSchoolActive && isBackToSchoolStyle
        ? backToSchoolTitle
        : fallback;
}
